import {Component, OnDestroy, OnInit} from '@angular/core';
import {FilterService} from '../../shared/filter.service';
import {SharedGrid} from '../../shared/grid.model';
import {BusinessRuleCoverageModel, BusinessRuleCoverageService} from './business-rule-coverage.service';
import {BaseDashboardComponent} from '../base-dashboard-component';

@Component({
    selector: 'app-business-rule-coverage',
    templateUrl: './business-rule-coverage.component.html',
    styleUrls: ['./business-rule-coverage.component.scss']
})
export class BusinessRuleCoverageComponent extends BaseDashboardComponent implements OnInit, OnDestroy {
    public coverage: BusinessRuleCoverageModel;
    public tableGrid = new SharedGrid();
    public isLoading = false;

    constructor(private filterService: FilterService, private serv: BusinessRuleCoverageService) {
        super();
        this.applyFilterSubscription = this.filterService.filterTriggered$.subscribe(this._loadData.bind(this));
    }

    ngOnInit() {}

    ngOnDestroy() {
        this.applyFilterSubscription.unsubscribe();
    }

    _loadData(searchOptions: any) {
        this.isLoading = true;
        this.serv.getBusinessRuleCoverage(searchOptions).subscribe(
            this._onLoadSuccess.bind(this),
            () => {
                this.isLoading = false;
            });
    }

    _onLoadSuccess(resp: BusinessRuleCoverageModel) {
        this.coverage = resp;
        this.tableGrid.gridData = resp.topRules;
        this.tableGrid.gridSort = [];
        this.isLoading = false;
    }
}
